<template>
  <div>
    <v-container fluid v-if="LoadingCustomer" class="pa-0">
      <v-layout class="calc-height" column pr-4>
        <v-flex class="calc-central-height">
          <v-layout fill-height align-center justify-center>
            <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card v-else flat class="transparent">
      <v-toolbar flat extended class="pt-3" extension-height="24">
        <v-btn v-if="!dialler" class="px-0 mx-0" icon small text @click="$router.go(-1)"
          ><v-icon class="mr-4">fa-chevron-left</v-icon></v-btn
        >
        <div>
          <h4 class="headline" v-if="showDetails">
            {{ customer.name }}
            <edit-business :customer="customer" v-if="canEdit"></edit-business>
          </h4>
          <h4 class="headline" v-else>Content Hidden</h4>
          <span class="subtitle-1 text--secondary">
            Registered:
            <span class="grey--text darken-1"
              >{{ [customer.created_at, 'YYYY-MM-DD H:mm:ss'] | moment('calendar') }} |</span
            >
          </span>
          <span class="subtitle-1 text--secondary pl-1">
            Requested: <span class="grey--text darken-1">{{ customer.funding | currency }} | </span>
          </span>
          <span v-if="canViewSource">
            <span class="subtitle-1 text--secondary pl-1" v-if="customer.referral">
              Source: <span class="grey--text darken-1">{{ customer.referrer.name }} | </span>
            </span>
            <span class="subtitle-1 text--secondary pl-1" v-else>
              Source: <span class="grey--text darken-1">Organic | </span>
            </span>
          </span>
          <span class="subtitle-1 text--secondary">
            Active Journey: <span class="grey--text darken-1">{{ activeJourney }}</span>
          </span>
        </div>
        <v-spacer></v-spacer>
        <customer-toolbar
          v-if="UserHasRole('Platform') || UserHasRole('Call Centre') || UserHasRole('Property Broker')"
          :customer="customer"
        ></customer-toolbar>
        <v-tooltip v-else-if="!UserHasRole('Broker')" left>
          <template v-slot:activator="{ on }">
            <v-avatar size="48" v-on="on">
              <img alt="" :src="avatarUrl" />
            </v-avatar>
          </template>
          <span>Owner: {{ customer.owner.name.first }} {{ customer.owner.name.last }}</span>
        </v-tooltip>
      </v-toolbar>

      <v-tabs background-color="grey lighten-3" class="my-0" v-model="customerTab">
        <v-tabs-slider color="accent"></v-tabs-slider>
        <v-tab
          key="answers"
          v-if="
            UserHasRole('Platform') ||
              UserHasRole('Call Centre') ||
              UserHasRole('Broker') ||
              UserHasRole('Property Broker') ||
              UserHasRole('Provider')
          "
        >
          <abf-question-completion-gauge
            :question_completion_percentage="customer.question_completion_percentage"
          ></abf-question-completion-gauge>
          Answers
        </v-tab>
        <v-tab key="summary">Summary</v-tab>
        <v-tab
          key="enquiries"
          v-if="
            UserHasRole('Platform') ||
              UserHasRole('Call Centre') ||
              UserHasRole('Broker') ||
              UserHasRole('Property Broker')
          "
          >Enquiries</v-tab
        >
        <v-tab
          key="activity"
          v-if="!UserHasRole('Provider') && !UserHasRole('Partner') && !UserHasRole('Property Broker')"
          @click="getCustomerActivity()"
          >Activity</v-tab
        >
      </v-tabs>

      <v-tabs-items v-model="customerTab" class="grey lighten-2">
        <v-tab-item
          key="answers"
          v-if="
            UserHasRole('Platform') ||
              UserHasRole('Call Centre') ||
              UserHasRole('Broker') ||
              UserHasRole('Property Broker') ||
              UserHasRole('Provider')
          "
        >
          <answers-container
            :exclusions="excludedBusinesses"
            :isBankReferral="isBankReferral"
            :dialler="dialler"
          ></answers-container>
        </v-tab-item>
        <v-tab-item key="summary">
          <customer-summary :customer="customer"></customer-summary>
        </v-tab-item>
        <v-tab-item
          key="enquiries"
          v-if="
            UserHasRole('Platform') ||
              UserHasRole('Call Centre') ||
              UserHasRole('Broker') ||
              UserHasRole('Property Broker')
          "
        >
          <v-layout>
            <v-flex xs12>
              <enquiries-container :enquiries="customer.enquiries"></enquiries-container>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item
          key="activity"
          v-if="!UserHasRole('Provider') && !UserHasRole('Partner') && !UserHasRole('Property Broker')"
        >
          <v-layout>
            <v-flex xs12 xl8>
              <activities></activities>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import CustomerSummary from './OverviewDrawer/Info/CustomerSummary';
import EnquiriesContainer from './OverviewDrawer/Enquiries/EnquiriesContainer';
import AbfQuestionCompletionGauge from '../../Abf/AbfQuestionCompletionGauge';
import CustomerToolbar from './Widgets/CustomerToolbar';
import Activities from './OverviewDrawer/Activity/Activities';
import AnswersContainer from './OverviewDrawer/Answers/AnswersContainer';
import EditBusiness from '@/components/Platform/Customers/Widgets/EditBusiness';

export default {
  name: 'Customer',
  components: {
    EditBusiness,
    AbfQuestionCompletionGauge,
    Activities,
    AnswersContainer,
    CustomerSummary,
    CustomerToolbar,
    EnquiriesContainer
  },
  props: {
    id: String,
    dialler: Boolean
  },
  data: () => ({
    customerTab: null,
    fab: false,
    page: 'customer'
  }),
  computed: {
    ...mapGetters([
      'LoadingCustomer',
      'SelectedCustomer',
      'UILeftDrawer',
      'UserHasRole',
      'JourneyTypes',
      'SelectedEnquiry',
      'SelectedPartner'
    ]),
    avatarUrl() {
      return `https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/avatars/${this.customer.owner.id}.png`;
    },
    canViewSource() {
      return !this.UserHasRole('Property Broker') && !this.UserHasRole('Broker') && !this.UserHasRole('Provider');
    },
    customer() {
      return this.SelectedCustomer;
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    canEdit: function() {
      return this.UserHasRole('Platform');
    },
    showDetails: function() {
      if (this.UserHasRole('Provider') && !this.UserHasRole('Property Broker')) {
        return (
          this.SelectedEnquiry.customer.id === this.SelectedCustomer.id &&
          this.SelectedEnquiry.active === true &&
          this.SelectedEnquiry.status.name !== 'PENDING'
        );
      }
      return true;
    },
    isBankReferral() {
      return this.customer.referrer && this.customer.referrer.type === 'bank';
    },
    referrerAccountId() {
      return this.customer.referrer && this.customer.referrer.account_id;
    },
    excludedBusinesses() {
      if (this.SelectedPartner && this.SelectedPartner.excluded_businesses) {
        return this.SelectedPartner.excluded_businesses.map(business => business.id);
      } else {
        return [];
      }
    },
    activeJourney() {
      return _.isUndefined(this.SelectedCustomer.active_journey) ? '' : this.SelectedCustomer.active_journey.name;
    }
  },
  methods: {
    ...mapActions([
      'getActivity',
      'getFunderEnquiry',
      'getJourneyTypes',
      'getOwnersList',
      'selectCustomer',
      'updateCustomer',
      'updateUILeftDrawerState'
    ]),
    switchFlag: function(flag) {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          [flag]: !this.customer[flag]
        }
      });
    },
    toggleClosed: function() {
      if (this.customer.closed) {
        this.switchFlag('closed');
      } else {
        this.showCloseDialog = true;
      }
    },
    getCustomerActivity: function() {
      this.getActivity(this.customer.id);
    }
  },
  watch: {
    id: function(id) {
      this.selectCustomer(id);
    }
  },
  mounted() {
    this.selectCustomer(this.id);
    this.getOwnersList();
  },
  beforeMount() {
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-central-height {
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
